import Login from '../pages/Login.vue'
import Callback from '../pages/Callback.vue'
import Logout from '../pages/Logout.vue'
import store from '@/store/index'

export const routes = [
  {
    path: '/login',
    name: 'Login',
    component: Login,
    meta: { isPublic: true }
  },
  {
    path: '/auth/callback',
    name: 'Callback',
    component: Callback,
    meta: { isPublic: true }
  },
  {
    path: '/logout',
    name: 'Logout',
    component: Logout,
    meta: { isPublic: true }
  }
]

export const registerGuards = (router) => {
  router.beforeEach(async (to/*, from*/) => {
    if (to.meta.isPublic !== true && !store.getters['auth/oidc/isAuthenticated']) {
      return { path: '/login', query: { returnUrl: to.fullPath } }
    }
    // console.log('auth guard', to, from)
  })
}